var _excluded = ["rows"],
  _excluded2 = ["width", "height", "maxPages", "pageCount", "enablePagination", "currentPage", "rowStyle", "rowRootClassName", "onClick", "onDoubleClick", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseOut", "onMouseOver", "onMouseUp", "onSelect", "onDeselect", "onPageChange", "skipRowHeightUpdates", "rows", "groups", "columns", "noResultsCell", "toolbar"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { css } from "../../../../styles/theme";
import TableUtil from "../Table/TableUtil";
import SelectionUtil from "../SelectionTable/SelectionUtil";
import ToolbarTableUtil from "./ToolbarTableUtil";
import ActionButton from "./ActionButton";
import TablePaginationControls from "./TablePaginationControls";
import { default as SelectionTable } from "../SelectionTable/SelectionTable";
import { default as Styles, TOOLBAR_HEIGHT, PAGINATION_HEIGHT } from "./ToolbarTableStyles";
var ToolbarTable = /*#__PURE__*/function (_React$Component) {
  function ToolbarTable(props) {
    var _this;
    _classCallCheck(this, ToolbarTable);
    _this = _callSuper(this, ToolbarTable, [props]);
    _defineProperty(_this, "_selectionTable", void 0);
    _defineProperty(_this, "toggleExpandRow", function (row) {
      _this.setState({
        expandedRows: TableUtil.updateExpandedRows(_this.state.expandedRows || {}, row)
      });
    });
    _this.state = _this.generateState(props);
    return _this;
  }
  _inherits(ToolbarTable, _React$Component);
  return _createClass(ToolbarTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var toolbar = this.props.toolbar;
      if (prevProps.toolbar.length !== toolbar.length || ToolbarTableUtil.toolbarHasChanged(toolbar, prevProps.toolbar)) {
        this.setState({
          toolbar: this.generateTools(toolbar)
        });
      }
    }
  }, {
    key: "rowInfo",
    value: function rowInfo(row, callback) {
      var _this$props = this.props,
        rows = _this$props.rows,
        groups = _this$props.groups;
      var _ref = row || {},
        $groupIndex = _ref.$groupIndex,
        $rowIndex = _ref.$rowIndex,
        $isGroupTitle = _ref.$isGroupTitle;
      if (rows && typeof $rowIndex === 'number') {
        return callback(rows[$rowIndex], $rowIndex);
      } else if (groups && typeof $groupIndex === 'number' && typeof $rowIndex === 'number') {
        return callback(groups[$groupIndex].rows[$rowIndex], $groupIndex, $rowIndex);
      } else if (groups && typeof $groupIndex === 'number' && $isGroupTitle) {
        return callback(groups[$groupIndex], $groupIndex, undefined, $isGroupTitle);
      }
    }
  }, {
    key: "getTable",
    value: function getTable() {
      return this._selectionTable && this._selectionTable.getTable();
    }
  }, {
    key: "getRowEventCallback",
    value: function getRowEventCallback(callback) {
      var _this2 = this;
      return function (event, row) {
        return _this2.rowInfo(row, function (row, index, secondary) {
          return callback(event, row, index, secondary);
        });
      };
    }
  }, {
    key: "getRowSelectionCallback",
    value: function getRowSelectionCallback(callback) {
      var _this3 = this;
      return function (row) {
        return _this3.rowInfo(row, callback);
      };
    }
  }, {
    key: "getTableHeight",
    value: function getTableHeight() {
      var _this$props2 = this.props,
        height = _this$props2.height,
        enablePagination = _this$props2.enablePagination;
      if (height === undefined) {
        return height;
      }
      var extrasHeight = TOOLBAR_HEIGHT;
      if (enablePagination) {
        extrasHeight += PAGINATION_HEIGHT;
      }
      // if a number is provided convert it to pixels
      var tableHeight = isNaN(height) ? height : "".concat(height, "px");
      return "calc(".concat(tableHeight, " - ").concat(extrasHeight, "px)");
    }
  }, {
    key: "generateState",
    value: function generateState(props) {
      var toolbar = props.toolbar;
      return {
        toolbar: this.generateTools(toolbar),
        expandedRows: {}
      };
    }
  }, {
    key: "generateTools",
    value: function generateTools(toolbar) {
      return toolbar.map(function (tool) {
        return ToolbarTableUtil.generateTool(tool);
      });
    }
  }, {
    key: "updateFilterValue",
    value: function updateFilterValue(toolIndex, value, customUpdateHandler) {
      var _this4 = this;
      var defaultUpdateHandler = function defaultUpdateHandler() {
        var table = _this4.getTable();
        // Since the filter value has changed, there will be changes in the rows, so we need to update the heights of
        // the rows.
        table && table.forceUpdateRowHeights();
        var _this4$props = _this4.props,
          rows = _this4$props.rows,
          groups = _this4$props.groups,
          onUpdateFilteredRowsAndGroups = _this4$props.onUpdateFilteredRowsAndGroups;
        if (onUpdateFilteredRowsAndGroups) {
          // Filter rows or groups
          var filteredRows = rows && _this4.filterRows(_this4.addMetaToRows(rows));
          var filteredGroups = groups && _this4.filterGroups(_this4.addMetaToGroups(groups));
          onUpdateFilteredRowsAndGroups({
            filteredGroups: filteredGroups,
            filteredRows: filteredRows
          });
        }
      };
      var updateHandler = customUpdateHandler || defaultUpdateHandler;
      this.setState(function (oldState) {
        var toolbar = oldState.toolbar.slice();
        toolbar[toolIndex].value = value;
        return {
          toolbar: toolbar
        };
      }, updateHandler);
    }
  }, {
    key: "filterRows",
    value: function filterRows(rows) {
      var toolbar = this.state.toolbar;
      return toolbar.reduce(function (rows, tool) {
        return tool.type === 'filter' ? ToolbarTableUtil.filterRowsWithTool(rows, tool) : rows;
      }, rows);
    }
  }, {
    key: "filterGroups",
    value: function filterGroups(groups) {
      var _this5 = this;
      var alwaysRenderGroupTitleRow = this.props.alwaysRenderGroupTitleRow;
      return groups.reduce(function (allGroups, group) {
        var rows = group.rows;
        var filteredRows = _this5.filterRows(rows);
        if (filteredRows.length) {
          return allGroups.concat(_objectSpread(_objectSpread({}, group), {}, {
            rows: filteredRows
          }));
        } else if (alwaysRenderGroupTitleRow) {
          return allGroups.concat(_objectSpread(_objectSpread({}, group), {}, {
            rows: []
          }));
        } else {
          return allGroups.concat([]);
        }
      }, []);
    }
  }, {
    key: "addMetaToRows",
    value: function addMetaToRows(rows) {
      return rows.map(function (row, rowIndex) {
        return _objectSpread(_objectSpread({}, row), {}, {
          $rowIndex: rowIndex
        });
      });
    }
  }, {
    key: "addMetaToGroups",
    value: function addMetaToGroups(groups) {
      return groups.map(function (group, groupIndex) {
        var rows = group.rows,
          rest = _objectWithoutProperties(group, _excluded);
        return _objectSpread(_objectSpread({}, rest), {}, {
          rows: rows.map(function (row, rowIndex) {
            return _objectSpread(_objectSpread({}, row), {}, {
              $groupIndex: groupIndex,
              $rowIndex: rowIndex
            });
          })
        });
      });
    }
  }, {
    key: "generateNoResultRow",
    value: function generateNoResultRow() {
      var _this$props3 = this.props,
        columns = _this$props3.columns,
        enableSelection = _this$props3.enableSelection;
      return _defineProperty(_defineProperty(_defineProperty({}, enableSelection ? 'selected' : columns[0].accessor, {
        cellContent: this.renderNoResultCell(),
        colSpan: enableSelection ? columns.length + 1 : columns.length
      }), "disabled", true), "$noResultRow", true);
    }
  }, {
    key: "generateRowsOrGroups",
    value: function generateRowsOrGroups() {
      var _this$props4 = this.props,
        rows = _this$props4.rows,
        groups = _this$props4.groups;

      // Filter rows or groups
      var filteredRows = rows && this.filterRows(this.addMetaToRows(rows));
      var filteredGroups = groups && this.filterGroups(this.addMetaToGroups(groups));

      // Check if there's filtered result. If not then use a single no result row
      var hasContent = filteredRows && filteredRows.length > 0 || filteredGroups && filteredGroups.length > 0;
      var generatedRows = hasContent ? filteredRows : [this.generateNoResultRow()];
      var generatedGroups = hasContent ? filteredGroups : undefined;

      // Return the rows/groups with meta ($rowIndex and $groupIndex)
      if (generatedRows) {
        return {
          rows: generatedRows
        };
      } else if (generatedGroups) {
        return {
          groups: generatedGroups
        };
      } else {
        throw new Error('Neither rows nor groups is specified');
      }
    }
  }, {
    key: "processColumnCellRenderers",
    value: function processColumnCellRenderers(columns) {
      var _this6 = this;
      return columns.map(function (column) {
        var _cellRenderer = column.cellRenderer;
        var obj = _cellRenderer && {
          cellRenderer: function cellRenderer(data, row) {
            return _this6.rowInfo(row, function (row, index, secondaryIndex) {
              return _cellRenderer(data, row, index, secondaryIndex, _this6.toggleExpandRow, _this6.state.expandedRows[row.key]);
            });
          }
        };
        return _objectSpread(_objectSpread({}, column), obj);
      });
    }
  }, {
    key: "generateColumns",
    value: function generateColumns() {
      var columns = this.props.columns;
      return this.processColumnCellRenderers(columns);
    }
  }, {
    key: "renderNoResultCell",
    value: function renderNoResultCell() {
      var noResultCell = this.props.noResultCell;
      return /*#__PURE__*/React.createElement("div", css(Styles.noResultCell), noResultCell || 'No result');
    }
  }, {
    key: "renderFilterTool",
    value: function renderFilterTool(tool, toolIndex) {
      var _this7 = this;
      return tool.renderer("".concat(toolIndex), tool.value, function (value) {
        return _this7.updateFilterValue(toolIndex, value, tool.onUpdate);
      });
    }
  }, {
    key: "renderSelectAll",
    value: function renderSelectAll(toolIndex) {
      var _this$props5 = this.props,
        rows = _this$props5.rows,
        groups = _this$props5.groups,
        onSelect = _this$props5.onSelect,
        onDeselect = _this$props5.onDeselect;
      // Filter rows or groups
      var filteredRows = rows && this.filterRows(this.addMetaToRows(rows));
      var filteredGroups = groups && this.filterGroups(this.addMetaToGroups(groups));
      var props = {
        rows: filteredRows,
        groups: filteredGroups,
        onSelect: onSelect,
        onDeselect: onDeselect
      };
      var checkbox = SelectionUtil.renderHeaderSelectAllCheckbox(props);
      return /*#__PURE__*/React.createElement("div", _extends({
        key: toolIndex
      }, css(Styles.selectAllWrapper)), checkbox);
    }
  }, {
    key: "renderSelectionAction",
    value: function renderSelectionAction(tool, toolIndex) {
      var _this$props6 = this.props,
        rows = _this$props6.rows,
        groups = _this$props6.groups;
      var toolbar = this.state.toolbar;

      // Get the style of this button. If next tool is also button, remove the margin (given by css)
      var nextTool = toolbar[toolIndex + 1];
      var needMarginRight = nextTool && nextTool.type !== 'selection-action';
      var style = needMarginRight ? css(Styles.actionButtonMargin) : {};

      // Generate the action button
      var selection = SelectionUtil.getSelection({
        rows: rows,
        groups: groups
      });
      var button = tool.renderer ? tool.renderer(selection) : /*#__PURE__*/React.createElement(ActionButton, {
        tool: tool,
        selection: selection
      });
      return /*#__PURE__*/React.createElement("div", _extends({
        key: toolIndex
      }, style), button);
    }
  }, {
    key: "renderGap",
    value: function renderGap(tool, toolIndex) {
      return /*#__PURE__*/React.createElement("div", {
        key: toolIndex
      }, tool.renderer());
    }
  }, {
    key: "renderTool",
    value: function renderTool(tool, toolIndex) {
      switch (tool.type) {
        case 'filter':
          return this.renderFilterTool(tool, toolIndex);
        case 'select-all':
          return this.renderSelectAll(toolIndex);
        case 'selection-action':
          return this.renderSelectionAction(tool, toolIndex);
        case 'gap':
          return this.renderGap(tool, toolIndex);
        case 'custom':
          return tool.renderer(toolIndex, tool.value, tool.onUpdate);
        default:
          return undefined;
      }
    }
  }, {
    key: "renderToolbar",
    value: function renderToolbar() {
      var _this8 = this;
      var toolbar = this.state.toolbar;
      return toolbar.map(function (tool, toolIndex) {
        return _this8.renderTool(tool, toolIndex);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;
      var _this$props7 = this.props,
        width = _this$props7.width,
        height = _this$props7.height,
        maxPages = _this$props7.maxPages,
        pageCount = _this$props7.pageCount,
        enablePagination = _this$props7.enablePagination,
        currentPage = _this$props7.currentPage,
        rowStyle = _this$props7.rowStyle,
        rowRootClassName = _this$props7.rowRootClassName,
        onClick = _this$props7.onClick,
        onDoubleClick = _this$props7.onDoubleClick,
        onMouseDown = _this$props7.onMouseDown,
        onMouseEnter = _this$props7.onMouseEnter,
        onMouseLeave = _this$props7.onMouseLeave,
        onMouseMove = _this$props7.onMouseMove,
        onMouseOut = _this$props7.onMouseOut,
        onMouseOver = _this$props7.onMouseOver,
        onMouseUp = _this$props7.onMouseUp,
        onSelect = _this$props7.onSelect,
        onDeselect = _this$props7.onDeselect,
        onPageChange = _this$props7.onPageChange,
        skipRowHeightUpdates = _this$props7.skipRowHeightUpdates,
        rows = _this$props7.rows,
        groups = _this$props7.groups,
        columns = _this$props7.columns,
        noResultsCell = _this$props7.noResultsCell,
        toolbar = _this$props7.toolbar,
        rest = _objectWithoutProperties(_this$props7, _excluded2);
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: width,
          height: height
        }
      }, /*#__PURE__*/React.createElement("div", css(Styles.toolbar, 'cui-toolbar'), this.renderToolbar()), /*#__PURE__*/React.createElement(SelectionTable, _extends({
        ref: function ref(_ref3) {
          return _this9._selectionTable = _ref3;
        },
        width: width,
        height: skipRowHeightUpdates ? undefined : this.getTableHeight(),
        columns: this.generateColumns(),
        expandedRows: this.state.expandedRows,
        rowStyle: rowStyle,
        rowRootClassName: rowRootClassName
      }, this.generateRowsOrGroups(), onClick && {
        onClick: this.getRowEventCallback(onClick)
      }, onDoubleClick && {
        onDoubleClick: this.getRowEventCallback(onDoubleClick)
      }, onMouseDown && {
        onMouseDown: this.getRowEventCallback(onMouseDown)
      }, onMouseEnter && {
        onMouseEnter: this.getRowEventCallback(onMouseEnter)
      }, onMouseLeave && {
        onMouseLeave: this.getRowEventCallback(onMouseLeave)
      }, onMouseMove && {
        onMouseMove: this.getRowEventCallback(onMouseMove)
      }, onMouseOut && {
        onMouseOut: this.getRowEventCallback(onMouseOut)
      }, onMouseOver && {
        onMouseOver: this.getRowEventCallback(onMouseOver)
      }, onMouseUp && {
        onMouseUp: this.getRowEventCallback(onMouseUp)
      }, onSelect && {
        onSelect: this.getRowSelectionCallback(onSelect)
      }, onDeselect && {
        onDeselect: this.getRowSelectionCallback(onDeselect)
      }, rest)), enablePagination && maxPages && pageCount > 0 && /*#__PURE__*/React.createElement(TablePaginationControls, {
        onPageChange: onPageChange,
        maxPages: maxPages,
        pageCount: pageCount,
        currentPage: currentPage
      }));
    }
  }]);
}(React.Component);
export default ToolbarTable;